export const isMainPartsEmpty = (mainParts: Array<{ id: string; code: string }>) => {
    return !mainParts.filter(item => {
        return item.id
    }).length
}

export const SortRank = (a, b) => {
    if (a.rank === null) {
        return 1
    }
    if (b.rank === null) {
        return -1
    }
    if (a.rank > b.rank) {
        return 1
    }
    if (a.rank < b.rank) {
        return -1
    }
    return 0
}
